import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Gt2ApiService } from '../../api/gt2-api.service';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { fuseAnimations } from '../../../../@fuse/animations/index';
import { FuseTranslationLoaderService } from '../../../../@fuse/services/translation-loader.service';
import { Gt2LocaleService } from '../../../localization/gt2-locale.service';
import { AuthenticationService } from '../../api/auth-service.service';
import { AddressComponent } from '../../components/address/address.component';
import { ContactComponent } from '../../components/contact/contact.component';
import { RolesService } from '../../services/roles.service';
import { Settings } from '../../settings/settings';
import { GT2FormPageAbstract } from '../abstract/GT2FormPageAbstract';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { GT2DateAdapter } from '../../utils/GT2DateAdapter';
import { CrudOrganizationService } from '../crud/crud-organization/crud-organization.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DataSource } from '@angular/cdk/collections';
import { ItemUrlFinder } from '../../utils/item-url-finder';
import { UserService } from '../../api/user.service';
import { Title } from '@angular/platform-browser';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AssetUploadService } from '../../services/asset-upload.service';
import { ModulesService } from '../../services/modules.service';
import { OrganizationIdentitiesService } from '../../api/organization-identities.service';
import { OrganizationIdentity } from '../../api/models/OrganizationIdentityModel';
import { AppRoutes } from '../../const/AppRoutes';
import { GenericAlertComponent } from '../../components/generic-alert/generic-alert.component';

@Component({
  selector: 'app-caterer',
  templateUrl: './caterer.component.html',
  styleUrls: ['./caterer.component.scss'],
  providers: [{ provide: DateAdapter, useClass: GT2DateAdapter }],
  animations: fuseAnimations,
})
export class CatererComponent
  extends GT2FormPageAbstract
  implements OnInit, OnDestroy
{
  @ViewChild('addressComponent') addressComponent?: AddressComponent;
  @ViewChild('contactComponent') contactComponent?: ContactComponent;
  @ViewChild('gtAppWhiteInput') gtAppWhiteInput!: ElementRef<HTMLInputElement>;
  @ViewChild('gtAppColorInput') gtAppColorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('productDefaultInput')
  productDefaultInput!: ElementRef<HTMLInputElement>;

  catererUUID!: string;
  shopUUID!: string;
  caterer: any;
  catererForm: UntypedFormGroup;
  override loading: boolean = false;
  editMode: boolean = false;
  isVisible: boolean = true;
  displayedOrganizationColumns: string[] = ['name', 'type', 'actionsColumn'];
  // orgListdataSource:
  orgList: any = {};
  identities: OrganizationIdentity[] = [];
  private modulesSubscription?: Subscription;
  isSmallScreen?: boolean = false;
  gtAppWhiteUploading: boolean = false;
  gtAppColorUploading: boolean = false;
  productDefaultUploading: boolean = false;
  // Cache-buster appended to asset preview URLs. The server returns bare,
  // stable URLs (e.g. ".../logo_white.png") with no anti-cache strategy, so
  // we compute a fresh value once per page load and once per upload — enough
  // to bypass the browser cache without re-fetching on every render.
  assetCacheBuster: number = Date.now();

  // logoUploadURL: string;
  // headerUploadURL: string;
  // uploadedFiles: any[] = [];
  // uploadedLogoResponse: LogoResponse;
  // uploadedLogoError: string;
  // uploadedHeaderResponse: ReportHeaderResponse;
  // uploadedHeaderError: string;

  // gt2AppSupportedLocale: LocaleModel[];
  // clientSupportedLocale: LocaleModel[] = [];

  // languages: any;
  // selectedLanguage: any;

  constructor(
    private auth: AuthenticationService,
    private logger: NGXLogger,
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private dialog: MatDialog,
    public translate: TranslateService,
    private translationLoader: FuseTranslationLoaderService,
    private toastr: ToastrService,
    private titleService: Title,
    private gt2LocaleService: Gt2LocaleService,
    private api: Gt2ApiService,
    public location: Location,
    public rolesService: RolesService,
    public userService: UserService,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    public router: Router,
    private orgService: CrudOrganizationService,
    private assetUploadService: AssetUploadService,
    public modulesService: ModulesService,
    private identitiesService: OrganizationIdentitiesService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);

    this.catererForm = this.formBuilder.group({
      name: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxChar),
          Validators.required,
        ],
      ],
      owner_user: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxChar),
          Validators.required,
        ],
      ],
    });

    this.setControlsChanges(this.catererForm);
    this.orgList.onOrgListChanged = new BehaviorSubject({});
    this.orgList.dataSource = new FilesDataSource(this.orgList);
  }

  ngOnInit() {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe({
      next: (result) => {
        this.isSmallScreen = result.matches;
      },
    });
    // this.logger.info("CatererComponent.ngOnInit()");

    //this.titleService.setTitle(this.translate.instant('CATERER.CATERER'));

    this.route.params.subscribe({
      next: (params: any) => {
        this.catererUUID = params.id;
        this.shopUUID = params.shop_uuid;
        this.loadCatererByUUID(this.catererUUID);
      },
    });

    this.modulesSubscription = this.modulesService.modulesSet.subscribe({
      next: (isSet: boolean) => {
        if (isSet) {
          this.loadIdentities();
        }
      },
    });
  }

  ngOnDestroy() {
    if (this.modulesSubscription) {
      this.modulesSubscription.unsubscribe();
    }
  }

  public loadCatererByUUID(uuid: string): void {
    this.loading = true;
    this.orgService.loadCatererByUUID(uuid).subscribe({
      next: (caterer) => {
        if (caterer.data) {
          this.caterer = caterer.data;
          this.assetCacheBuster = Date.now();
          this.buildOrgList();

          //this.titleService.setTitle(
          //  this.translate.instant('CATERER.CATERER') + ' ' + this.caterer.name,
          //);
        }
        this.loading = false;
      },
      error: (error) => {
        this.logger.error(
          'CatererComponent.loadCatererByUUID() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.handleAPIError(error, this.dialog, null, null, this.router);
      },
    });
  }

  public override autosaveDataChange(data: any): void | any {
    this.loading = true;
    this.orgService.updateCaterer(data, this.catererUUID).subscribe({
      next: (response) => {
        this.loading = false;
      },
      error: (error) => {
        this.logger.error(
          'CatererComponent.autosaveDataChange() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.loading = false;
        this.handleAPIError(
          error,
          this.dialog,
          this.toastr,
          this.translate.instant('GENERIC.ERRORS.GENERIC') + ' CAT001',
          this.router,
        );
      },
    });
  }

  public onEdit($event: any): void {
    this.editMode = !this.editMode;

    if (this.addressComponent) {
      this.addressComponent.editMode = this.editMode;
    }

    if (this.contactComponent) {
      this.contactComponent.editMode = this.editMode;
    }

    if (this.editMode) {
      this.setControlsChanges(this.catererForm);
    } else {
      this.unsetControlsChanges();
      this.catererForm.markAsPristine();
      this.catererForm.markAsUntouched();
    }
  }

  public onEditOrganization(org: any): void {
    const prefix = localStorage.getItem('PREFIX') || '';
    this.router.navigateByUrl(prefix + ItemUrlFinder.getItemURL(org));
  }

  public loadIdentities(): void {
    if (!this.modulesService.hasOrgIdentity()) {
      this.identities = [];
      this.buildOrgList();
      return;
    }
    this.identitiesService.getAll().subscribe({
      next: (response) => {
        this.identities = response.data || [];
        this.buildOrgList();
      },
      error: (error) => {
        this.logger.error(
          'CatererComponent.loadIdentities() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.identities = [];
        this.buildOrgList();
      },
    });
  }

  /**
   * Merges the internal organizations and the organization identities into a
   * single list, tagging each row with a `rowType` so the table can render the
   * "Type" column and dispatch the row actions accordingly.
   */
  public buildOrgList(): void {
    const organizations = (
      (this.caterer && this.caterer.organizations) ||
      []
    ).map((org: any) => ({ ...org, rowType: 'organization' }));
    const identities = this.identities.map((identity) => ({
      ...identity,
      rowType: 'identity',
    }));
    this.orgList.onOrgListChanged.next([...organizations, ...identities]);
  }

  public onEditRow(row: any): void {
    if (row && row.rowType === 'identity') {
      this.onEditIdentity(row);
    } else {
      this.onEditOrganization(row);
    }
  }

  public onEditIdentity(identity: any): void {
    this.router.navigateByUrl(
      '/' +
        this.shopUUID +
        '/' +
        AppRoutes.ORGANIZATION_IDENTITY +
        '/' +
        identity.uuid,
    );
  }

  public onCreateIdentity(): void {
    this.router.navigateByUrl(
      '/' + this.shopUUID + '/' + AppRoutes.ORGANIZATION_IDENTITY + '/new',
    );
  }

  public onDeleteIdentity(identity: any): void {
    const confirmDialogRef = this.dialog.open(GenericAlertComponent, {
      disableClose: false,
    });
    confirmDialogRef.componentInstance.useCancel = true;
    confirmDialogRef.componentInstance.alertTitle =
      this.translate.instant('GENERIC.DELETE');
    confirmDialogRef.componentInstance.alertMessage = this.translate.instant(
      'GENERIC.DELETE_CONFIRM',
    );

    confirmDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          this.identitiesService.delete(identity.uuid).subscribe({
            next: () => {
              this.toastr.success(
                this.translate.instant('CATERER.IDENTITY_DELETE_SUCCESS'),
              );
              this.loadIdentities();
            },
            error: (error: any) => {
              this.logger.error(
                'CatererComponent.onDeleteIdentity() -> ERROR: ' +
                  JSON.stringify(error),
              );
              this.handleAPIError(
                error,
                this.dialog,
                this.toastr,
                this.translate.instant('GENERIC.ERRORS.GENERIC') + ' CAT002',
                this.router,
              );
            },
          });
        }
      },
    });
  }

  public onOpenInNewTab(): void {
    this.openInNewTab(this.router.url);
  }

  public onOwnerUserChange(event: any): void {
    this.caterer.owner_user = event;
    this.autosaveDataChange({ owner_user: this.caterer.owner_user });
  }

  public onSelectAssetFile(assetType: string): void {
    switch (assetType) {
      case 'gt_app_white':
        this.gtAppWhiteInput.nativeElement.click();
        break;
      case 'gt_app_color':
        this.gtAppColorInput.nativeElement.click();
        break;
      case 'product_default':
        this.productDefaultInput.nativeElement.click();
        break;
    }
  }

  public onAssetFileSelected(event: Event, assetType: string): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const file = input.files[0];

    if (file.type !== 'image/png') {
      this.toastr.error(
        this.translate.instant('CATERER.LOGO_INVALID_FORMAT'),
      );
      input.value = '';
      return;
    }

    const isProductDefault = assetType === 'product_default';
    const requiredW = isProductDefault ? 250 : 272;
    const requiredH = isProductDefault ? 250 : 72;

    const img = new Image();
    img.onload = () => {
      if (img.width !== requiredW || img.height !== requiredH) {
        this.toastr.error(
          this.translate.instant(
            isProductDefault
              ? 'CATERER.PRODUCT_DEFAULT_INVALID_DIMENSIONS'
              : 'CATERER.LOGO_INVALID_DIMENSIONS',
          ),
        );
        input.value = '';
        return;
      }
      this.uploadAsset(file, assetType);
      input.value = '';
    };
    img.onerror = () => {
      this.toastr.error(
        this.translate.instant('CATERER.LOGO_INVALID_FORMAT'),
      );
      input.value = '';
    };
    img.src = URL.createObjectURL(file);
  }

  private uploadAsset(file: File, assetType: string): void {
    if (assetType === 'gt_app_white') {
      this.gtAppWhiteUploading = true;
    } else if (assetType === 'gt_app_color') {
      this.gtAppColorUploading = true;
    } else {
      this.productDefaultUploading = true;
    }

    this.assetUploadService.uploadAsset(file, assetType).subscribe({
      next: (response: any) => {
        this.assetCacheBuster = Date.now();
        if (assetType === 'gt_app_white') {
          this.caterer.gt_app_logo_white = response.url;
          this.gtAppWhiteUploading = false;
        } else if (assetType === 'gt_app_color') {
          this.caterer.gt_app_logo_color = response.url;
          this.gtAppColorUploading = false;
        } else {
          this.caterer.product_default_image = response.url;
          this.productDefaultUploading = false;
        }
        this.toastr.success(
          this.translate.instant('CATERER.UPLOAD_ASSET_SUCCESS'),
        );
      },
      error: (error: any) => {
        if (assetType === 'gt_app_white') {
          this.gtAppWhiteUploading = false;
        } else if (assetType === 'gt_app_color') {
          this.gtAppColorUploading = false;
        } else {
          this.productDefaultUploading = false;
        }
        this.logger.error(
          'CatererComponent.uploadAsset() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.toastr.error(
          this.translate.instant('CATERER.UPLOAD_ASSET_ERROR'),
        );
      },
    });
  }
}

export class FilesDataSource extends DataSource<any> {
  constructor(private orgList: any) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<any[]> {
    return this.orgList.onOrgListChanged;
  }

  disconnect() {}
}
